import { Outlet } from 'react-router-dom';
import useEntry from '../../application/bloc/useEntry';
import PageTemplate from '../templates/PageTemplate/PageTemplate';
import PageTemplateKt from '../templates/PageTemplate/PageTemplateKt';
import PageTemplateLgu from '../templates/PageTemplate/PageTemplateLgu';
import { MEDIA_NAME } from '../../application/types/types';
import { Skeleton, BridgeModal, Popup } from 'oui';

const Entry = () => {
  const {
    isLoading,
    media,
    isOpenBridgeModal,
    setIsReady,
    lguIOSWarning,
    onConfirmLguIOSWarning,
  } = useEntry();

  const Template =
    media === MEDIA_NAME.SKT
      ? PageTemplate
      : media === MEDIA_NAME.KT
      ? PageTemplateKt
      : media === MEDIA_NAME.LGU
      ? PageTemplateLgu
      : PageTemplate;

  return (
    <>
      {!isLoading ? (
        <Skeleton type={'a'} />
      ) : (
        <Template>
          {/*<p onClick={() => navigate('/mtg/conditions/1')}>주담대 정보입력</p>*/}
          <Outlet />
        </Template>
      )}

      <BridgeModal
        isBridgeModalOpen={isOpenBridgeModal}
        message={'오버테이크의 대출비교 서비스로\n 이동 중이에요'}
        timeout={2000}
        onDone={() => setIsReady(true)}
      />
      <Popup
        isPopupOpen={lguIOSWarning.showLguIosWarning}
        title={lguIOSWarning.message}
        confirmBtn={{
          text: lguIOSWarning.confirmText,
          onClick: onConfirmLguIOSWarning,
        }}
      />
    </>
  );
};

export default Entry;
